module.exports = "/images/img_tshirt_3.png?236d871ac954393da091b2efaf924bc9";